import React, { useEffect, useState } from 'react';
import FormSelect from '../../common/FormSelect/FormSelect';
import FormTextarea from '../../common/FormTextarea/FormTextarea';
import {
  STUDENT_INACTIVATION_REASON_OPTIONS,
  isStudentInactivationReason,
  type StudentInactivationReason,
} from '../../../constants/studentInactivationReason';
import { useEscapeToClose } from '../../../hooks/useEscapeToClose';
import styles from './CreateSubscriptionModal.module.css';

interface SubscriptionCancellationReasonModalProps {
  open: boolean;
  subscriptionName: string | null;
  onProceed: (reason: StudentInactivationReason, observation: string | null) => void;
  onCancel: () => void;
}

const SubscriptionCancellationReasonModal: React.FC<SubscriptionCancellationReasonModalProps> = ({
  open,
  subscriptionName,
  onProceed,
  onCancel,
}) => {
  const [reason, setReason] = useState('');
  const [observation, setObservation] = useState('');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) {
      setReason('');
      setObservation('');
      setError(null);
    }
  }, [open]);

  useEscapeToClose(onCancel, open);

  if (!open) return null;

  const handleProceed = () => {
    if (!isStudentInactivationReason(reason)) {
      setError('Selecione o motivo do cancelamento.');
      return;
    }
    onProceed(reason, observation.trim() || null);
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()} style={{ width: 480, alignItems: 'stretch' }}>
        <div className={styles['icon-circle']} style={{ alignSelf: 'center' }}>
          <span className="material-symbols-outlined">cancel</span>
        </div>

        <h3 className={styles.title}>Cancelar assinatura</h3>
        <p className={styles.message}>
          Selecione o motivo do cancelamento
          {subscriptionName ? ` da assinatura "${subscriptionName}"` : ''}.
        </p>

        <FormSelect
          id="subscription-cancellation-reason"
          label="Motivo do cancelamento"
          name="cancellationReason"
          value={reason}
          onChange={(e) => {
            setReason(e.target.value);
            if (error) setError(null);
          }}
          options={[...STUDENT_INACTIVATION_REASON_OPTIONS]}
          placeholder="Selecione o motivo"
          error={error ?? undefined}
          required
          containerClassName={styles['select-wrap']}
        />

        <FormTextarea
          id="subscription-cancellation-observation"
          label="Observação"
          name="cancellationObservation"
          value={observation}
          onChange={(event) => setObservation(event.target.value)}
          placeholder="Escreva uma observação, se quiser"
          rows={3}
          containerClassName={styles['select-wrap']}
        />

        <div className={styles.actions}>
          <button
            type="button"
            className={`${styles.btn} ${styles['btn-cancel']}`}
            onClick={onCancel}
          >
            Voltar
          </button>
          <button
            type="button"
            className={`${styles.btn} ${styles['btn-confirm']}`}
            onClick={handleProceed}
            style={{ backgroundColor: 'var(--color-solid-danger)' }}
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancellationReasonModal;
